import axios from 'axios'
import { Store } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import Notification from '../app-main-content/playlistAdds/Notification'

import {
    GET_CATEGORIES_FOR_ADMIN_REQUEST,
    GET_CATEGORIES_FOR_ADMIN_FAIL,
    GET_CATEGORIES_FOR_ADMIN_SUCCESS,
    
    GET_CATEGORY_REQUEST,
    GET_CATEGORY_FAIL,
    GET_CATEGORY_SUCCESS,

    GET_CATEGORY_TAGS_REQUEST,
    GET_CATEGORY_TAGS_FAIL,
    GET_CATEGORY_TAGS_SUCCESS,

    ADD_CATEGORY_REQUEST,
    ADD_CATEGORY_FAIL,
    ADD_CATEGORY_SUCCESS,   

    UPDATE_CATEGORY_REQUEST,
    UPDATE_CATEGORY_FAIL,
    UPDATE_CATEGORY_SUCCESS,

    DELETE_CATEGORY_REQUEST,
    DELETE_CATEGORY_FAIL,
    DELETE_CATEGORY_SUCCESS,

    ADD_CATEGORY_TAG_REQUEST,
    ADD_CATEGORY_TAG_FAIL,
    ADD_CATEGORY_TAG_SUCCESS,

    REMOVE_CATEGORY_TAG_REQUEST,
    REMOVE_CATEGORY_TAG_FAIL,
    REMOVE_CATEGORY_TAG_SUCCESS,
} from '../constants/AdminCategoryConstants'



export const getCategoriesForAdmin = () => async (dispatch, getState) => {

    const config = {
        headers:{
            'Content-type':'application/json',
            'Authorization': `JWT ${localStorage.getItem('access')}`,
            'Accept': 'application/json'
          }
        }

    try {
        dispatch({
        type: GET_CATEGORIES_FOR_ADMIN_REQUEST
        })

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/cuviewTV/get_categories_for_admin/`, config
        )

        dispatch({
        type: GET_CATEGORIES_FOR_ADMIN_SUCCESS,
        payload: data
        })

    } catch(error) {
        dispatch({
        type: GET_CATEGORIES_FOR_ADMIN_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        })
    }
}


export const getCategory = (category_id) => async (dispatch, getState) => {

    const config = {
        headers:{
            'Content-type':'application/json',
            'Authorization': `JWT ${localStorage.getItem('access')}`,
            'Accept': 'application/json'
          }
        }

    try {
        dispatch({
        type: GET_CATEGORY_REQUEST
        })

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/cuviewTV/get_category/${category_id}/`, config
        )

        dispatch({
        type: GET_CATEGORY_SUCCESS,
        payload: data
        })

    } catch(error) {
        dispatch({
        type: GET_CATEGORY_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        })
    }
}


export const getCategoryTags = (category_id) => async (dispatch, getState) => {
    try {

        const config = {
            headers:{
                'Content-type':'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
              }
            }

        dispatch({
        type: GET_CATEGORY_TAGS_REQUEST
        })

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/cuviewTV/get_category_tags/${category_id}/`, config
        )

        dispatch({
        type: GET_CATEGORY_TAGS_SUCCESS,
        payload: data
        })

    } catch(error) {
        dispatch({
        type: GET_CATEGORY_TAGS_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        })
    }
}

export const addCategory = (title, status, image) => async (dispatch, getState) => {

    
    if (localStorage.getItem('access')){
        const config = {
            headers:{
                'Content-type':'multipart/form-data',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
              }
        }

        try {
            dispatch({
                type:ADD_CATEGORY_REQUEST
            })
    
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/cuviewTV/add_category/`,
                { 'title': title, 'status' : status, "image" : image },
                config
            )
            
            dispatch({
                type:ADD_CATEGORY_SUCCESS,
                payload: res.data
            })

            Store.addNotification({
                content: <Notification message = {"Category has been added successfully"}/>,
                type: 'custom',
                container: "bottom-left",
                insert: "top",
                dismiss: {
                    duration: 3000,
                    pauseOnHover: true
                }
            })
    
    
        } catch(error) {
            dispatch({
            type:ADD_CATEGORY_FAIL,
            payload: error.response && error.response.data.message
            ? error.response.data.message
            : error.message
            })


            Store.addNotification({
                content: <Notification message = {"Add Category Failed"}/>,
                type: 'custom',
                container: "bottom-left",
                insert: "top",
                dismiss: {
                    duration: 3000,
                    pauseOnHover: true
                }
            })
        }

    }
}


export const editCategory = (category_id, category_title, category_status, image ) => async (dispatch, getState) => {
    
    if (localStorage.getItem('access')){
        const config = {
            headers:{
                'Content-type':'multipart/form-data',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
              }
        }

        try {
            dispatch({
                type: UPDATE_CATEGORY_REQUEST
            })
    
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/cuviewTV/update_category/${category_id}/`,
                { 'title': category_title, 'status' : category_status, 'image' : image },
                config
            )
            
            dispatch({
                type: UPDATE_CATEGORY_SUCCESS,
                payload: res.data
            })
    
        } catch(error) {
            dispatch({
            type: UPDATE_CATEGORY_FAIL,
            payload: error.response && error.response.data.message
            ? error.response.data.message
            : error.message
            })
        }

    }
}


export const deleteCategory = (category_id) => async (dispatch, getState) => {

    const config = {
        headers:{
            'Content-type':'application/json',
            'Authorization': `JWT ${localStorage.getItem('access')}`,
            'Accept': 'application/json'
          }
        }

    try {
        dispatch({
        type:DELETE_CATEGORY_REQUEST
        })

        const res  = await axios.delete(
            `${process.env.REACT_APP_API_URL}/cuviewTV/delete_category/${category_id}/`, config
        )

        dispatch({
          type:DELETE_CATEGORY_SUCCESS,
          payload: res.data,
          category_id: category_id
        })

        Store.addNotification({
            content: <Notification message = {"Category has been removed"}/>,
            type: 'custom',
            container: "bottom-left",
            insert: "top",
            dismiss: {
                duration: 3000,
                pauseOnHover: true
            }
        })

    } catch(error) {
        dispatch({
        type:DELETE_CATEGORY_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        })

        Store.addNotification({
            content: <Notification message = {"Deleting has failed"}/>,
            type: 'custom',
            container: "bottom-left",
            insert: "top",
            dismiss: {
                duration: 3000,
                pauseOnHover: true
            }
        })

    }
}


export const addCategoryTag = (category_id, tag_id) => async (dispatch, getState) => {
    try {

        const config = {
            headers:{
                'Content-type':'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
              }
            }

        dispatch({
        type: ADD_CATEGORY_TAG_REQUEST
        })

        const { data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/cuviewTV/add_category_tag/${tag_id}/${category_id}/`, config
        )

        dispatch({
        type: ADD_CATEGORY_TAG_SUCCESS,
        payload: data
        })

        Store.addNotification({
            content: <Notification message = {"Tag has been added successfully"}/>,
            type: 'custom',
            container: "bottom-left",
            insert: "top",
            dismiss: {
                duration: 3000,
                pauseOnHover: true
            }
        })

    } catch(error) {
        dispatch({
        type: ADD_CATEGORY_TAG_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        })

        Store.addNotification({
            content: <Notification message = {"Adding Tag has failed"}/>,
            type: 'custom',
            container: "bottom-left",
            insert: "top",
            dismiss: {
                duration: 3000,
                pauseOnHover: true
            }
        })
    }
}



export const deleteCategoryTag = (tag_id, category_id) => async (dispatch, getState) => {

    const config = {
        headers:{
            'Content-type':'application/json',
            'Authorization': `JWT ${localStorage.getItem('access')}`,
            'Accept': 'application/json'
          }
        }

    try {
        dispatch({
        type:REMOVE_CATEGORY_TAG_REQUEST
        })

        const res  = await axios.delete(
            `${process.env.REACT_APP_API_URL}/cuviewTV/remove_category_tag/${tag_id}/${category_id}/`, config
        )

        dispatch({
          type:REMOVE_CATEGORY_TAG_SUCCESS,
          payload: res.data,
          tag_id: tag_id
        })

        Store.addNotification({
            content: <Notification message = {"Tag has been deleted"}/>,
            type: 'custom',
            container: "bottom-left",
            insert: "top",
            dismiss: {
                duration: 3000,
                pauseOnHover: true
            }
        })

    } catch(error) {
        dispatch({
        type:REMOVE_CATEGORY_TAG_FAIL,
        payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        })

        Store.addNotification({
            content: <Notification message = {"Deleting failed"}/>,
            type: 'custom',
            container: "bottom-left",
            insert: "top",
            dismiss: {
                duration: 3000,
                pauseOnHover: true
            }
        })
    }
}